<fin-flight-card
  [flightOrBound]="boundsOrFlights[activeBoundIndex]"
  [title]="
    locations[boundsOrFlights[activeBoundIndex].departure.locationCode].cityName +
    ' - ' +
    locations[boundsOrFlights[activeBoundIndex].arrival.locationCode].cityName
  "
  [locations]="locations"
  [passengers]="passengers"
  [hideModify]="true"
  (viewDetails)="viewDetails.emit()"
>
  <div class="ps-medium-y">
    <div class="ps-medium-t ps-medium-x border-top flex flex--center">
      <fcom-button
        *ngIf="boundsOrFlights.length > 1"
        class="flex--nogrow"
        [text]="'carousel.previous' | finLocalization"
        [aria]="{
          label:
            ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.previousBound' : 'actions.previousFlight')
            | finLocalization,
        }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [disabled]="activeBoundIndex === 0"
        data-testid="service-selection-prev-segment"
        (clickBtn)="activeBoundIndex !== 0 && onChangeFlightBound(activeBoundIndex - 1, -1)"
      />
      <div class="progress flex-1 flex flex--row flex--center ps-medium-x">
        <span
          class="rounded-large alert-50-bg ps-xsmall-r ps-xxsmall-y font-body-1 flex flex--wrap flex--center font-body-medium"
        >
          <span class="ps-xsmall-l">{{ 'services.flight' | finLocalization }}</span>
          <span data-testid="service-selection-segment-progress" class="ps-xsmall-l"
            >{{ activeBoundIndex + 1 }} / {{ boundsOrFlights.length }}</span
          >
        </span>
      </div>
      <fcom-button
        *ngIf="boundsOrFlights.length > 1"
        class="flex--nogrow"
        [text]="'carousel.next' | finLocalization"
        [aria]="{
          label:
            ($any(boundsOrFlights[activeBoundIndex]).itinerary ? 'actions.nextBound' : 'actions.nextFlight')
            | finLocalization,
        }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [disabled]="activeBoundIndex === boundsOrFlights.length - 1"
        data-testid="service-selection-next-segment"
        (clickBtn)="activeBoundIndex !== boundsOrFlights.length - 1 && onChangeFlightBound(activeBoundIndex + 1, 1)"
      />
    </div>
  </div>
</fin-flight-card>
